import { Box, BoxProps } from '@chakra-ui/react'
import type { ReactNode } from 'react'

interface ChartWrapperProps {
  children: ReactNode
  height?: number | string
  paddingTop?: string
}

const ChartWrapper = ({
  children,
  paddingTop,
  ...rest
}: ChartWrapperProps & BoxProps) => {
  return (
    <Box
      bg="bg.default"
      borderRadius="10px"
      border="1px solid"
      borderColor="border.default"
      p="1rem"
      pt={paddingTop ?? '1rem'}
      width="100%"
      {...rest}
    >
      {children}
    </Box>
  )
}

export default ChartWrapper
